import { Skeleton, Tab, useTheme } from '@mui/material';
import { type WatchlistCategory } from '#components/Watchlist/WatchlistCategory.ts';
import { tt } from '#i18n/index.ts';

export type WatchlistTabProps = {
  disabled?: boolean;
  loading: boolean;
  value: WatchlistCategory;
};

export const WatchlistTab = ({ disabled = false, loading, value, ...rest }: WatchlistTabProps) => {
  const theme = useTheme();

  const tabSx = {
    [theme.breakpoints.down('md')]: {
      minHeight: '40px',
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      paddingTop: theme.spacing(0),
    },
    '&.Mui-disabled': {
      color: theme.palette.grey[400],
    },
  };

  if (loading) {
    return (
      <Skeleton
        sx={{
          [theme.breakpoints.down('md')]: {
            marginY: '10px',
          },
          [theme.breakpoints.down('sm')]: {
            width: '150px',
          },
          marginX: theme.spacing(2),
          marginY: '14px',
        }}
        variant="rectangular"
      />
    );
  }

  return <Tab disabled={disabled} label={tt(`watchlist.categories.${value}`)} sx={tabSx} value={value} {...rest} />;
};
